module.exports = "../dist/img/img_1-38.9aad.jpg";